module.exports = __webpack_public_path__ + "img/product9.e23ae8de.png";